import http from '@/shared/services/01_axios'
import type {
  ApiResponse,
  GetNotificationParams,
  NotificationItem,
  UnreadNotificationSummary,
} from './types'
import { notificationUrls } from './urls'

export const NotificationService = {
  getNewNotification: (): Promise<ApiResponse<UnreadNotificationSummary[]>> => {
    return http.get(notificationUrls.getNewNotification)
  },

  getListNotify: (params?: GetNotificationParams): Promise<ApiResponse<NotificationItem[]>> => {
    const queryParams: Record<string, any> = {}
    if (params) {
      if (params.textSearch !== undefined) queryParams.TextSearch = params.textSearch
      if (params.isRead !== undefined) {
        queryParams.IsRead =
          typeof params.isRead === 'boolean' ? (params.isRead ? 1 : 0) : params.isRead
      }
      if (params.pageSize !== undefined) queryParams.PageSize = params.pageSize
      if (params.currentPage !== undefined || params.pageIndex !== undefined) {
        queryParams.CurrentPage = params.currentPage ?? params.pageIndex
      }
    }
    return http.get(notificationUrls.getListNotify, { params: queryParams })
  },

  markAsSeen: (notificationId = ''): Promise<ApiResponse<boolean>> => {
    return http.post(notificationUrls.markAsSeen, null, {
      params: { NotifyId: notificationId },
    })
  },

  markAsRead: (notificationId = ''): Promise<ApiResponse<boolean>> => {
    return http.post(notificationUrls.markAsRead, null, {
      params: { NotifyId: notificationId },
    })
  },

  deleteNotification: (notificationId = ''): Promise<ApiResponse<boolean>> => {
    return http.post(notificationUrls.deleteNotification, null, {
      params: { NotifyId: notificationId },
    })
  },
}

export * from './types'
export * from './urls'
